<template>      
   <div>
      <div class="row">
          <p>
              Credits : &copy;Julien Cabot - 2019-2020
          </p>
          <hr/>
          <p>
            Version : {{ appVersion }} <br/>
            Environment : {{ environment }} <br/>
            PSN : {{ this.user.athlete.progSeqNum }}
          </p>
          <hr/>
          <div v-if="isDevMode()" class="row">
            ADVANCED MODE <br/>
            <div class="input-field col s6">
              <input type="number" step="1" min="0" class="validate" v-model.number.lazy="progSeqNum">
              <span class="helper-text" >Prog Sequence Number</span>
            </div>
            <div class="col s6">

              <button class="btn" v-on:click="forceSessionUpdate()">CHANGE</button>
            </div>
          </div>
      </div>
   </div>
</template>
<script>
import api from '@/api'
import M from 'materialize-css'
export default {
  name: 'credits',
  data: function () {
    return {
      user: undefined,
      progSeqNum: undefined,
      appVersion: undefined,
      environment: undefined
    }
  },
  created () {
    this.user = api.getCurrentUser()
    this.progSeqNum = this.user.athlete.progSeqNum
    this.appVersion = process.env.APP_VERSION
    this.environment = process.env.NODE_ENV
  },
  methods: {
    isDevMode () {
      return process.env.NODE_ENV !== 'production' || process.env.ALLOW_DEV_MODE
    },
    forceSessionUpdate () {
      if (this.isDevMode) {
        this.user.athlete.forceSessionRefresh = true
        api.update(this.user)
        M.toast({html: 'Program Sequence Number forced changed'})
      }
    }
  },
  watch: {
    progSeqNum: function (val) {
      this.user.athlete.progSeqNum = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Credits.vue